import { useEffect, useState, type JSX } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

// Tiny banner that appears when the SW finds new content. Click "Reload" to apply.
// Hidden in dev (vite-plugin-pwa skips registration unless `devOptions.enabled`).
export function UpdatePrompt(): JSX.Element | null {
  const [show, setShow] = useState(false);
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      // Quiet success — nothing to render until an update lands.
      void registration;
    },
    onRegisterError(err) {
      console.error('SW register failed:', err);
    },
  });

  useEffect(() => {
    if (needRefresh) setShow(true);
  }, [needRefresh]);

  if (!show) return null;
  return (
    <div
      role="status"
      className="fixed inset-x-0 bottom-0 z-[60] flex items-center justify-between gap-4 border-t border-slate-200 bg-white p-3 text-sm dark:border-slate-700 dark:bg-slate-900"
    >
      <span>A new version is available.</span>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => setShow(false)}
          className="rounded-xl border border-slate-300 px-3 py-1.5 text-xs dark:border-slate-700"
        >
          Later
        </button>
        <button
          type="button"
          onClick={() => updateServiceWorker(true)}
          className="rounded-xl bg-slate-900 px-3 py-1.5 text-xs font-medium text-white dark:bg-slate-50 dark:text-slate-900"
        >
          Reload
        </button>
      </div>
    </div>
  );
}
